import { gql } from 'graphql-tag';

export const sendAlarmLimitRequestEmail = gql`
  mutation sendAlarmLimitRequestEmail($input: AlarmLimitRequest) {
    sendAlarmLimitRequestEmail(input: $input) {
      value
    }
  }
`;
